// Picovoice Configuration
// Add your Picovoice Access Key here

export const PICOVOICE_CONFIG = {
  // Replace with your actual Picovoice Access Key from https://console.picovoice.ai/
  ACCESS_KEY: 'RW4ebc4UkEzhq495ele0DzY7XbODWWTJkTtPk9UoWmtA22z6KEEKQQ==',

  // Wake word settings
  WAKE_WORD: {
    keyword: 'hey clinic',
    sensitivity: 0.5 // Adjust between 0.0 (less sensitive) and 1.0 (more sensitive)
  },

  // Voice command settings
  VOICE_COMMANDS: {
    timeout: 5000, // ms to wait for command after wake word
    language: 'en-US'
  }
};

// Instructions:
// 1. Go to https://console.picovoice.ai/
// 2. Sign in to your account
// 3. Copy your Access Key
// 4. Replace 'YOUR_PICOVOICE_ACCESS_KEY_HERE' above with your actual key
// 5. Optionally adjust sensitivity (0.5 is a good starting point)